import * as React from 'react';

import SVGBase from '../svg-base/svg-base';

export interface SortNumberAscProps {
    fill?: string;
    title?: string;
    height?: string;
    width?: string;
    viewBox?: string;
}

const SortNumberAsc: React.FunctionComponent<React.PropsWithChildren<SortNumberAscProps>> = ({
    fill = '#00b1ff',
    title,
    height,
    width,
    ...rest
}): any => (
    <SVGBase viewBox="0 0 50 50" height={height} width={width} title={title} {...rest}>
        <path
            id="Path_11"
            className="sort-number-asc-icon__background"
            d="M4,0H46a4,4,0,0,1,4,4V46a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z"
            fill={fill}
        />
        <path
            className="sort-number-asc-icon__outline"
            d="M 4 1 C 2.345790863037109 1 1 2.345790863037109 1 4 L 1 46 C 1 47.65420913696289 2.345790863037109 49 4 49 L 46 49 C 47.65420913696289 49 49 47.65420913696289 49 46 L 49 4 C 49 2.345790863037109 47.65420913696289 1 46 1 L 4 1 M 4 0 L 46 0 C 48.20914077758789 0 50 1.790859222412109 50 4 L 50 46 C 50 48.20914077758789 48.20914077758789 50 46 50 L 4 50 C 1.790859222412109 50 0 48.20914077758789 0 46 L 0 4 C 0 1.790859222412109 1.790859222412109 0 4 0 Z"
            stroke="none"
            fill="#d5d5d5"
        />
        <text
            id="_1"
            className="sort-number-asc-icon__1"
            transform="translate(29 22)"
            fill="#fff"
            fontSize="18"
            fontFamily="open-sans"
            fontWeight="700"
        >
            <tspan x="0" y="0">
                1
            </tspan>
        </text>
        <text
            id="_9"
            className="sort-number-asc-icon__9"
            transform="translate(29 42)"
            fill="#fff"
            fontSize="18"
            fontFamily="open-sans"
            fontWeight="700"
        >
            <tspan x="0" y="0">
                9
            </tspan>
        </text>
        <path
            id="long-arrow-alt-left"
            className="sort-number-asc-icon__arrow"
            d="M6.465,3.381H26.674a.579.579,0,0,1,.579.579v2.7a.579.579,0,0,1-.579.579H6.465V9.46a1.157,1.157,0,0,1-1.976.818L.339,6.128a1.157,1.157,0,0,1,0-1.637L4.489.341a1.157,1.157,0,0,1,1.976.818V3.381Z"
            transform="translate(10.667 38.786) rotate(-90)"
            fill="#fff"
        />
    </SVGBase>
);

export default SortNumberAsc;
